"use client";
import type { Locales } from "@/i18n/i18nConfig";
import { type FaqLinkBase, getFaqLinkBase } from "@/utils/faq/faq-urls";
import { createContext, type FunctionComponent, type PropsWithChildren, useContext } from "react";

type FaqSite = { language: Locales; linkBase: FaqLinkBase };

// The FAQ layout decides the link base from the request's host. Client components read it here, because
// the address in the browser cannot tell them: on faq.reshopper.com it is a rewrite of the /faq route.
const FaqSiteContext = createContext<FaqSite>({ language: "da", linkBase: getFaqLinkBase(false) });

export const FaqSiteProvider: FunctionComponent<PropsWithChildren<FaqSite>> = ({ language, linkBase, children }) => (
	<FaqSiteContext.Provider value={{ language, linkBase }}>{children}</FaqSiteContext.Provider>
);

export const useFaqSite = () => useContext(FaqSiteContext);
